const OPERATORS = {
    afriplayglobal: {
        operator_id: '234',
        operator_uid: 'afriplayglobal',
        username_prefix: 'afp',
        country: '',
        api_url: "https://ott.tvanywhereafrica.com:28182",
    },

    afriplayghana: {
        operator_id: '235',
        operator_uid: 'afriplayghana',
        username_prefix: 'afpgh',
        country: 'Ghana (gh)',
        api_url: "https://ott.tvanywhereafrica.com:28182",
    },

    afriplaymtnghana: {
        operator_id: '237',
        operator_uid: 'afriplaymtnghana',
        username_prefix: 'amngh',
        country: 'Ghana (gh)',
        api_url: "https://ott.tvanywhereafrica.com:28182",
    },

    afriplaynigeria: {
        operator_id: '236',
        operator_uid: 'afriplaynigeria',
        username_prefix: 'afpng',
        country: 'Nigeria (ng)',
        api_url: "https://ott.tvanywhereafrica.com:28182",
    },
}

export default OPERATORS